<template>
  <DBox
    :id="'cmp-accounting-costs-cost_sidewindow-recoupables'"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      :id="'accounting-costs-cost_sidewindow-recoupables dbox1'"
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :showNoItems="true"
      autoLoad
    >
      <template v-slot:item="{ item, tdcon, index }">
        <tr>
          
          <td v-bind="tdcon('recoupables')">
            <span class="txtov" :title="item['balance_date']">
              {{ item["balance_date"] }}
            </span>
          </td>
          <td v-bind="tdcon('assigned_to')">
            <span class="txtov" :title="item['royalty_account_name']">
              {{ item.royalty_account_name }}
            </span>
          </td>
          <td v-bind="tdcon('description')">
            <TextField2
              :id="'description'"
              :showLabel="false"
              :value="item['description']"
              @blur="(e) => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('costgroup')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :options="costGroupTV"
              :selected="costGroupTV.find((e) => e.value == item.cost_group_id)"
              :placeholder="$t('costgroup')"
              v-on:selectedChange="
                (e) => onDropdownChange('cost_group_id', e, item)
              "
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('amount')">
            <div class="amount_content">
              <TextField2
                style="width: 88%"
                :ta="'right'"
                :id="'amount'"
                :type="'number'"
                :showLabel="false"
                :value="item['amount']"
                @blur="(e) => onTextFieldValueChange(e, item)"
              />
              <span> {{ $store.getters.account.client.default_currency }}</span>
            </div>
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => onDeleteRecoupable(item)"
              class="dt-icon s2 v5"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import { AccountingStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { createTableHeader } from "../../../../plugins/datatable";
import { createTV, tv } from "../../../../models/text-value.model";
import DBox from "@dtplugins/dbox/dbox";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { CostsService } from "../../services/costs.service";
export default {
  components: {
    NTable,
    DBox,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      recoupables: [],
      invoiceHeaders: [],
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("recoupables"),
        createTableHeader("assigned_to"),
        createTableHeader("description", { minw: 340 }),
        createTableHeader("costgroup"),
        createTableHeader("amount", { ta: "right", mw: 150 }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },

    list: function () {
      return this.selectedCostsDetails?.recoupables || [];
    },
    costGroupTV: function () {
      return createTV(
        this.selectedCostsDetails?.cost_groups,
        "cost_group_name",
        "cost_group_id"
      );
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.balance_id,
        table: "l_balances",
      });
      this.updateData(item);
    },
    onDropdownChange: function (name, value, item) {
      item[name] = value.value;
      this.$emit("changed", {
        name,
        value: value.value,
        kVal: item.balance_id,
        table: "l_balances",
      });
      this.updateData(item);
    },
    updateData: function (item) {
      const recoupables = this.selectedCostsDetails.recoupables.map((b) => {
        if (b.balance_id === item.balance_id) {
          b = {
            ...item,
          };
        }
        return b;
      });

      this[ActionTypes.AccountingCostRecopables.SET.ALL]({
        invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
        recoupables: recoupables || [],
      });
    },

    onDeleteRecoupable: async function (item) {
      const confirmationResult = await confirmDelete(
        "Recoupable",
        item.royalty_account_name
      );
      if (confirmationResult === "OK") {
        const res = await CostsService.deleteRoyaltyAccountsRecoupables(
          item.balance_id
        );
        const recoupables = this.selectedCostsDetails.recoupables.filter(
          (b) => b.balance_id !== item.balance_id
        );
        this[ActionTypes.AccountingCostRecopables.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          recoupables: recoupables || [],
        });
      }
    },
  },
};
</script>


<style lang="scss">
.cmp-accounting-costs-cost_sidewindow-recoupables {
  .amount_content {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
